"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteQuestion = void 0;
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const processDB_1 = require("./processDB");
function deleteQuestion(db, qId, suppressParent) {
    if (!db.questions[qId])
        return;
    const { parentListId, parentListIdx, childListIds } = db.questions[qId];
    const parentList = db.lists[parentListId];
    parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.splice(parentListIdx, 1);
    if (childListIds) {
        childListIds === null || childListIds === void 0 ? void 0 : childListIds.forEach(lid => {
            const childList = db.lists[lid];
            childList.childQIds.forEach(qqId => deleteQuestion(db, qqId, true));
            delete db.lists[lid];
        });
    }
    delete db.questions[qId];
    if ((parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.length) === 0 && !!db.defaultSubQuestionType) {
        const newQ = (0, createFormQuestion_1.default)({ type: db.defaultSubQuestionType });
        db.questions[newQ.qId] = newQ;
        parentList.childQIds = [newQ.qId];
    }
    if (!suppressParent)
        (0, processDB_1.processListParent)(db, parentList);
    // if it was added after deleting the last question, it is bound to be empty
    // but we do not want to delete that.
    if ((parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.length) > 1) {
        // Remove any empty questions from parentList
        parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.forEach(qqId => {
            var _a;
            if (((_a = db.questions[qqId]) === null || _a === void 0 ? void 0 : _a.title) === '')
                deleteQuestion(db, qqId, true);
        });
    }
    return true;
}
exports.deleteQuestion = deleteQuestion;
exports.default = deleteQuestion;
